import { FC } from 'react'
import {
  BooleanInput, Create, ReferenceInput, SelectInput, SimpleForm, TextInput, required, useTranslate,
} from 'react-admin'
import OpenApiUrlField from './OpenApiUrlField'

const ProxyCreate: FC = () => {
  const translate = useTranslate()

  return (
    <Create redirect="show">
      <SimpleForm defaultValues={{
        enabled: true,
        // eslint-disable-next-line camelcase
        tool_source: 'manual',
      }}>
        <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
        <TextInput source="description" label="data.description" fullWidth multiline />
        <ReferenceInput source="application_id" reference="application">
          <SelectInput optionText="display_name" label="data.application" fullWidth emptyText="-" />
        </ReferenceInput>
        {/* eslint-disable-next-line camelcase */}
        <SelectInput
          source="tool_source"
          label="data.toolSource"
          fullWidth
          validate={required()}
          choices={[
            { id: 'openapi', name: translate('data.toolSourceOpenapi') },
            { id: 'manual', name: translate('data.toolSourceManual') },
          ]}
        />
        <OpenApiUrlField showToggle />
        <BooleanInput source="enabled" label="data.enabled" defaultValue={true} />
      </SimpleForm>
    </Create>
  )
}

export default ProxyCreate
